import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/content/about/icon/firework.png")